import React, { useEffect } from 'react';
import { Link, navigate } from 'gatsby';
import { Grid } from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import { WindowLocation } from '@reach/router';

import SEO from 'src/components/SEO';
import withLocation from 'src/components/withLocation';
import PasswordForm from 'src/components/auth/PasswordForm';

import { LinkWithArrow } from 'src/components/shared';
import { SUI_GRID_CENTERED } from 'src/utils/semantic-utils';

import * as authStyles from 'src/styles/auth.module.scss';

interface LoginPasswordPageProps {
    location: WindowLocation;
}

const LoginPasswordPage = ({ location: { state } }: LoginPasswordPageProps) => {
    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (!state || isEmpty(state?.email)) {
            navigate('/continue');
        }
    }, []);

    if (!state || isEmpty(state?.email)) {
        return null;
    }

    const { widths } = SUI_GRID_CENTERED;

    return (
        <div className={authStyles.authWrapper}>
            <SEO title="P.Volve Login" />
            <Grid container centered>
                <Grid.Row>
                    <Grid.Column
                        mobile={widths.mobile}
                        tablet={widths.tablet}
                        computer={widths.computer}
                    >
                        <p className="p1">
                            {state?.firstName
                                ? `Welcome back, ${state?.firstName}!`
                                : 'Welcome back!'}
                        </p>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <PasswordForm email={state?.email} redirectUrl={state?.redirectUrl} />
            <Grid className={authStyles.bottomContent} container centered>
                <Grid.Row>
                    <Grid.Column
                        mobile={widths.mobile}
                        tablet={widths.tablet}
                        computer={widths.computer}
                        textAlign="center"
                    >
                        <p>
                            <Link to="/loginHelp" state={{ email: state?.email }}>
                                <b>I forgot my password. </b>
                                <b aria-hidden="true">¯\_(ツ)_/¯</b>
                            </Link>
                        </p>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column
                        mobile={widths.mobile}
                        tablet={widths.tablet}
                        computer={widths.computer}
                        textAlign="center"
                    >
                        <LinkWithArrow back centered label="Go back" to="/continue" />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </div>
    );
};

export default withLocation(LoginPasswordPage);
